import { useRouter } from "next/router";
import { useState } from "react";
import { Button } from "react-aria-components";
import useMeasure from "react-use-measure";

import {
  UserDataAvatar,
  UserDataGradeScore,
  UserDataJobTitle,
  UserDataNameAndProfile,
} from "@/components/shared/layout/navbar/header/UserDataContent";
import { UserDropdownItem } from "@/components/shared/layout/navbar/header/UserDropdownItem";
import { TreatsButton } from "@/components/shared/layout/sidebar/TreatsButton";
import { Dropdown } from "@/components/ui/overlays/Dropdown/Dropdown";
import { RouteConfig } from "@/config/route.config";
import { AuthContext } from "@/data/auth/auth.context";
import { DemoContext } from "@/providers/demo/DemoContext";

const USER_DROPDOWN_POPOVER_CLASS =
  "rounded-xs min-w-60 border border-elevation-outline-default-1 bg-elevation-fill-default-1 p-0! shadow-1 outline-hidden";

export const UserDataDropdown = () => {
  const [triggerRef, { width }] = useMeasure();
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const { logout } = AuthContext.useAuth();
  const { isDemoMode } = DemoContext.useDemo();

  const closeDropdown = () => setIsOpen(false);

  const handleViewProfile = () => {
    router.push(RouteConfig.Profile);
    closeDropdown();
  };

  const handleSettings = () => {
    router.push(RouteConfig.Settings);
    closeDropdown();
  };

  // const handleDemoMode = () => {
  //   router.push(RouteConfig.DemoHome);
  //   closeDropdown();
  // };

  const handleBugReporter = () => {
    if (isDemoMode) return;
    router.push(`${RouteConfig.BugReport}?source=${encodeURIComponent(window.location.href)}`);
    closeDropdown();
  };

  const handleLogout = () => {
    logout();
    closeDropdown();
  };

  return (
    <Dropdown
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      customTrigger={
        <div
          ref={triggerRef}
          className="flex min-w-0 flex-row items-center justify-center gap-2 p-2"
        >
          <Button
            className="flex cursor-pointer items-center justify-center outline-hidden hover:bg-elevation-fill-default-2"
            aria-label="Open user menu"
          >
            <UserDataAvatar />
          </Button>
          <div className="@[500px]/userdata:flex hidden min-w-0 flex-col gap-1">
            <UserDataNameAndProfile />
            <div className="flex flex-row items-center justify-between gap-1">
              <UserDataJobTitle />
              <UserDataGradeScore />
              <TreatsButton />
            </div>
          </div>
          <div className="@[180px]/userdata:flex @[500px]/userdata:hidden hidden shrink-0 flex-col items-start gap-1">
            <UserDataGradeScore />
            <TreatsButton />
          </div>
        </div>
      }
      popoverProps={{
        className: USER_DROPDOWN_POPOVER_CLASS,
        style: { width: width || undefined },
        offset: 10,
      }}
    >
      <div className="flex flex-col overflow-hidden rounded-xs">
        <UserDropdownItem
          label="View Profile"
          onClick={handleViewProfile}
        />
        <UserDropdownItem
          label="Settings"
          onClick={handleSettings}
        />
        {/* {!isDemoMode && (
          <UserDropdownItem
            label="Demo mode"
            onClick={handleDemoMode}
          />
        )} */}
        <UserDropdownItem
          label="Bug reporter"
          onClick={handleBugReporter}
        />
        <UserDropdownItem
          label="Log out"
          onClick={handleLogout}
          variant="destructive"
        />
      </div>
    </Dropdown>
  );
};
